function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import './avatar.scss';
import React, { memo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Icon, Spinner, useTheme } from '..';
const Avatar = _ref => {
  let {
    backgroundColor,
    bordered,
    className,
    classNameWrap,
    color,
    customIcon,
    icon,
    image,
    letter,
    loading,
    onClick,
    onDelete,
    size,
    yellowColor,
    ...rest
  } = _ref;
  const {
    theme
  } = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('wrts-avatar-wrap', classNameWrap),
    onClick: onClick
  }, loading ? /*#__PURE__*/React.createElement(Spinner, null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: classNames('wrts-avatar', className, color, size, theme, {
      'with-img': image,
      'with-letter': !image && letter,
      yellow: backgroundColor === yellowColor,
      'with-delete': !!onDelete,
      bordered
    }),
    style: {
      backgroundColor: !image && backgroundColor,
      backgroundImage: image ? `url(${image})` : undefined
    }
  }), letter && !image && /*#__PURE__*/React.createElement("span", {
    className: "letter"
  }, letter), !image && /*#__PURE__*/React.createElement(Icon, {
    name: icon || 'person'
  }), onDelete && /*#__PURE__*/React.createElement("button", {
    className: "delete-btn",
    onClick: onDelete
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close"
  }))), customIcon && /*#__PURE__*/React.createElement("img", {
    className: "type",
    src: customIcon,
    alt: "notification-type"
  })));
};
Avatar.propTypes = {
  backgroundColor: PropTypes.string,
  bordered: PropTypes.bool,
  className: PropTypes.string,
  classNameWrap: PropTypes.string,
  color: PropTypes.string,
  customIcon: PropTypes.string,
  icon: PropTypes.string,
  image: PropTypes.string,
  letter: PropTypes.string,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
  size: PropTypes.string,
  yellowColor: PropTypes.string
};
Avatar.defaultProps = {
  onClick: () => {},
  onDelete: () => {},
  yellowColor: '#FFD600'
};
export default /*#__PURE__*/memo(Avatar);